import React from "react";
import { get } from "lodash";
import type { TrackLocation } from "@tvg/ts-types/Race";
import { HighlightedStyle } from "@tvg/ts-types/Race";
import { Paragraph } from "@tvg/design-system";
import { buildQaLabel } from "@tvg/test-utils/utils";
import { Block, Container } from "./styled-components";
import type { Props } from "./types";
import { Flag } from "../Flag";
import type { Countries } from "../Flag/types";
import { RaceIcons } from "../RaceIcons";
import { useColorTokens } from "../../hooks";
import { getFlagLabel } from "../../utils/getFlagLabel";
import { CONTAINER, FLAG, LOCATION, TEXT } from "../../utils/constants";

export const TrackLocationDisplay = ({ race, qaLabel = "" }: Props) => {
  const { content } = useColorTokens();

  const isHighlighted =
    race?.highlighted?.style === HighlightedStyle.Highlighted;
  const location: TrackLocation | undefined = get(race, "track.location");

  return (
    <Container data-qa-label={buildQaLabel([qaLabel, LOCATION, CONTAINER])}>
      <Block>
        {!!location?.country && (
          <Flag
            country={location.country as Countries}
            size="s"
            qaLabel={buildQaLabel([qaLabel, LOCATION, FLAG])}
          />
        )}
        <Paragraph
          qaLabel={buildQaLabel([qaLabel, LOCATION, FLAG, TEXT])}
          color={isHighlighted ? content.onDark : content.subtle}
          fontFamily="regular"
          fontSize={12}
        >
          {getFlagLabel(location)}
        </Paragraph>
      </Block>
      <RaceIcons race={race} qaLabel={buildQaLabel([qaLabel, LOCATION])} />
    </Container>
  );
};
